import { createContext, useContext } from 'react';

export type TabContextValue = {
  tabId: string;
  isActive: boolean;
};

export const TabContext = createContext<TabContextValue | null>(null);

export function useTabId(): string {
  const ctx = useContext(TabContext);
  if (!ctx) {
    throw new Error('useTabId must be used inside a <TabContext.Provider>');
  }
  return ctx.tabId;
}

// Outside a tab (fullscreen routes, shell-level overlays), nothing is "inactive" —
// return true so consumers don't have to special-case the absence of a tab.
export function useActiveTab(): boolean {
  return useContext(TabContext)?.isActive ?? true;
}
